<template>
  <div class="baseClass">
    <div class="content">
      <div class="formItem">
        <span class="item-title"><i>*</i>{{$t('common_form_real_name')}}：</span>
        <a-input :placeholder="$t('credentials_请与证件名称保持一致')" class="login-input" v-model="form.personalLeadName" />
      </div>

      <div class="formItem">
        <span class="item-title"><i>*</i>{{$t('credentials_身份证号码')}}：</span>
        <a-input :placeholder="$t('credentials_请输入证件号码')" class="login-input" v-model="form.personalCertificateNo" />
      </div>

      <div class="formItem">
        <span class="item-title"><i>*</i>{{$t('credentials_身份证照片')}}：</span>
        <div class="up-domian">
          <div style="display:flex;">
            <span class="upload-example">
              <img src="@/assets/z1.png" v-if="!form.frontImgUrl" alt="" />
              <img class="idcard-avatar" v-if="form.frontImgUrl" style="width: 100%;height: 100%;" :src="form.frontImgUrl" alt="avatar" />
            </span>
            <div class="clearfix">
              <a-upload
                name="avatar"
                list-type="picture-card"
                accept="image/jpeg,image/jpg,image/png,image/jpg,image/bmp"
                class="avatar-uploader"
                :show-upload-list="false"
                :before-upload="frontChange"
              >
                <div class="color-upoload">
                  <a-icon :type="loading ? 'loading' : 'plus'" />
                  <div class="ant-upload-text">
                    {{$t('common_upload')}}
                  </div>
                </div>
              </a-upload>
            </div>
          </div>
          <div style="display:flex;margin-top: 10px;">
            <span class="upload-example">
              <img v-if="!form.behindImgUrl" src="@/assets/z2.png" alt="" />
              <img class="idcard-avatar" v-if="form.behindImgUrl" :src="form.behindImgUrl" style="width: 100%;height: 100%;" alt="avatar" />
            </span>
            <div class="clearfix">
              <a-upload
                name="avatar"
                list-type="picture-card"
                class="avatar-uploader"
                accept="image/jpeg,image/jpg,image/png,image/jpg,image/bmp"
                :show-upload-list="false"
                :before-upload="behindChange"
              >
                <div class="color-upoload">
                  <a-icon :type="behindLoading ? 'loading' : 'plus'" />
                  <div class="ant-upload-text">
                    {{$t('common_upload')}}
                  </div>
                </div>
              </a-upload>
            </div>
          </div>
          <div class="up-tips"><i>*</i>{{$t('credentials_请上传本人手持身份证正反面照片；支持.jpg .jpeg .bmp .png格式照片，大小不超过2M')}}</div>
        </div>
      </div>
    </div>
    <div class="bottomBox">
      <a-button @click="backToTab" type="" style="min-width: 60px;margin-right: 12px;">
        {{$t('credentials_返回')}}
      </a-button>
      <a-button @click="submit" type="primary">
        {{$t('credentials_提交审核')}}
      </a-button>
    </div>
  </div>
</template>

<script>
import { ACCESS_TOKEN } from '@/store/mutation-types'
import { openNotificationWithIcon, encrypt, decrypt } from '@/utils/util'
import api from '@/api/index'
import { SsoSetSubject } from '@/api/login'
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      form: {
        personalLeadName: undefined,
        personalCertificateNo: undefined,
        frontImgUrl: '',
        behindImgUrl: ''
      },
      loading: false,
      behindLoading: false
    }
  },
  computed: {
    ...mapGetters(['personalData'])
  },
  methods: {
    backToTab () {
      this.$emit('backToTab')
    },
    submit () {
      if (!this.form.personalLeadName) return openNotificationWithIcon(this.$t('childAct_输入姓名'))
      // const nameReg = /^\s+|\s+$|\d+/
      const nameReg = /^\s+|\s+$/

      if (nameReg.test(this.form.personalLeadName)) return openNotificationWithIcon(this.$t('credentials_姓名前后不能包含空格'))
      if (!this.form.personalCertificateNo) return openNotificationWithIcon(this.$t('请输入证件号码'))
      if (!this.form.frontImgUrl) return openNotificationWithIcon(this.$t('credentials_请上传身份证照片'))
      if (!this.form.behindImgUrl) return openNotificationWithIcon(this.$t('credentials_请上传身份证照片'))
      let params = {
        personalLeadName: this.form.personalLeadName,
        personalCertificateNo: encrypt(this.form.personalCertificateNo || ''),
        personalCertificateUrl: this.form.frontImgUrl + ',' + this.form.behindImgUrl,
        authenticationType: 1,
        extId: this.personalData.subjectStatus === 1 ? null : this.personalData.extId
      }
      SsoSetSubject(params).then(res => {
        if (res.code === '200') {
          this.$emit('submit')
        } else {
          openNotificationWithIcon(res.message)
        }
      })
    },
    // 前置页面
    frontChange (file) {
      if (file.size / 1024 / 1024 > 2) {
        this.$message.error(this.$t('credentials_文件大于2MB哦') + '!')
        return false
      }
      const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/bmp' || file.type === 'image/jpg'
      if (!isJpgOrPng) {
        this.$message.error(this.$t('credentials_请上传JPG、png、bmp、jpg文件') + '!')
        return false
      }
      this.loading = true
      var vFD = new FormData()
      vFD.append('file', file)
      vFD.append('source', 'verify')
      vFD.append('token', this.$ls.get(ACCESS_TOKEN))
      this.saveFile(vFD, (data) => {
        this.form.frontImgUrl = JSON.parse(data.currentTarget.response).data
        this.loading = false
      })
      return false
    },
    // 后置页面
    behindChange (file) {
      if (file.size / 1024 / 1024 > 2) {
        this.$message.error(this.$t('credentials_文件大于2MB哦') + '!')
        return false
      }
      const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/bmp' || file.type === 'image/jpg'
      if (!isJpgOrPng) {
        this.$message.error('请上传JPG、png、bmp、jpg文件!')
        return false
      }
      this.behindLoading = true
      var vFD = new FormData()
      vFD.append('file', file)
      vFD.append('side', 'front')
      vFD.append('source', 'verify')
      vFD.append('token', this.$ls.get(ACCESS_TOKEN))
      this.saveFile(vFD, (data) => {
        this.form.behindImgUrl = JSON.parse(data.currentTarget.response).data
        this.behindLoading = false
      })
      return false
    },
    saveFile (vFD, callBack) {
      var xhr = new XMLHttpRequest()
      xhr.open(
        'post',
        `${api.UpLoadImg}`
      )
      xhr.send(vFD)
      xhr.addEventListener('readystatechange', function (data) { // 原生返回
        if (xhr.readyState === 4) {
          if (xhr.status === 200) {
            // console.log(JSON.parse(data.currentTarget.response))
            if (JSON.parse(data.currentTarget.response).code === '200') {
              return callBack(data)
            } else {
              openNotificationWithIcon(JSON.parse(data.currentTarget.response).message)
            }
          }
        }
      })
    }
  },
  watch: {
    personalData: {
      handler: function (val) {
        if (val && Object.keys(val).length) {
          this.form.personalLeadName = this.personalData?.personalLeadName || undefined
          this.form.personalCertificateNo = decrypt(this.personalData?.personalCertificateNo || '')
          this.form.frontImgUrl = this.personalData?.personalCertificateUrl?.split(',')[0] || ''
          this.form.behindImgUrl = this.personalData?.personalCertificateUrl?.split(',')[1] || ''
        }
      },
      immediate: true
    }
  }
}
</script>

<style lang="less" scoped>
.baseClass {
  color: rgba(0, 0, 0, 0.85);
  height: calc(100vh - 209px);
  overflow-y: auto;
  .content {
    padding-bottom: 55px;
    // padding-left: 12px;
  }
  .color-upoload {
    color: #4978D6;
  }
  .formItem {
    display: inline-flex;
    width: 100%;
    margin-bottom: 16px;
  }
  .up-tips {
    font-weight:400;
    color:#555555;
    font-size:12px;
    // margin-top: 15px;
    margin-bottom: 16px;
    i {
      color: #E02020;
    }
  }
  .item-title {
    min-width: 130px;
    text-align: right;
    font-size: 12px;
    margin-right: 12px;
    line-height: 30px;
    display: inline-block;
    i {
      color: #E02020;
    }
    .item-opt {
      font-size: 14px;
      margin-left: 20px;
    }
  }
  .idcard-avatar {
    width: 93px;
    height: 93px;
  }
  .up-domian /deep/ .ant-upload-list-picture-card .ant-upload-list-item {
    width: 108px;
    height: 111px;
  }
  .login-input {
    display: inline-block;
    width: 210px;
    height: 30px;
    border-radius: 2px;
    border: 1px solid #D9D9D9;
  }
  /deep/ .ant-btn {
    border-radius: 2px;
  }
  .upload-example {
    display: inline-block;
    width: 210px;
    height: 104px;
    border: 1px dashed #DDDDDD;
    text-align: center;
    margin-right: 12px;
    line-height: 110px;
    img {
      width: 71px;
      height: 73px;
      margin-top: -10px;
    }
  }
  .bottom-btn {
    width: 100%;
    position: relative;
    left: 147px;
  }
}
.bottomBox {
  position: absolute;
  bottom: -56px;
  // width: 100%;
  left: -12px;
  right: -12px;
  bottom: 0;
  height: 56px;
  box-shadow: 0px -2px 2px 0px rgba(152, 161, 171, 0.17);
  display: flex;
  justify-content: center;
  align-items: center;
  background: #fff;
}
</style>
